import { api } from "@/shared/api";

/**
 * ADV-UI-2 军师开屏简报(2026-08-18,契约=军师线 ADV-UI-1 草案 + 回执三条):
 * GET /api/v1/advisor/briefing,console 走既有 backend 代理,鉴权同 /advisor/skills(单信封,
 * api.get 已解 ApiResponse.data)。
 *
 * 契约要点(字段增删两边同改,别单边兜底):
 * - greeting.text / runningItems[].title/.line 全是 ai 模板拼装的**成品人话**,console 原样渲染
 *   零加工零改写;
 * - chips 点击语义 = 把 text 填进输入框走自动路由,**不直接派单**(老板机制红线);
 * - mode=cold_start:greeting 仍非空(平实问候)、runningItems=[]、chips 为通用示例;
 * - route 原样用但**不原样信**:console 侧只认站内相对路径(见 isSafeInternalRoute)。
 */

export type BriefingMode = "personalized" | "cold_start";

export interface BriefingRunningItem {
  id: string;
  kind: "poster" | "video" | "talking_head" | "article" | "campaign" | "blueprint";
  title: string;
  state: "running" | "just_done" | "failed_unbilled" | "partial";
  line: string;
  route: string;
}

export interface BriefingChip {
  id: string;
  text: string;
  source: "profile" | "recent" | "generic";
}

export interface AdvisorBriefing {
  kind: "briefing";
  mode: BriefingMode;
  greeting: { text: string; factsAnchored: boolean };
  runningItems: BriefingRunningItem[];
  chips: BriefingChip[];
  generatedAt: string;
}

/**
 * route 站内白名单:只认以单个 "/" 开头的相对路径(拒绝协议、域名、"//host"、"javascript:" 形态)。
 * ai 侧模板事故把外链/脏值带进来时,卡片降级为不可点,绝不跳出站。
 */
export function isSafeInternalRoute(route: unknown): route is string {
  return typeof route === "string" && /^\/(?!\/)/.test(route);
}

export const advisorBriefingApi = {
  get: () => api.get<AdvisorBriefing>("/advisor/briefing"),
};
